<template>
  <div>
    <van-nav-bar fixed title="领用出库" left-arrow @click-left="onClickLeft" />

    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px;">
      <van-cell
          icon="location-o"
          :title="currentAgent.name"
          is-link
          to="pwalist"
          style="border-bottom:0.1px solid 	#F5F5F5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false">
      <van-cell icon="edit" style="border-bottom:0.1px solid 	#F5F5F5">
        <van-field
            v-model="message"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="科室领用"
            show-word-limit
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="出库明细" :border="false">
      <van-cell class="box">
        <van-swipe-cell
            v-for="(item,index) in outStockDetail"
            :key="index"
            :class="{selecteddetail:defaultDetail==index}"
            @click="toggleDetail(index)"
        >
          <van-cell-group :border="false">
            <van-cell class="detailcell">
              <van-row class="ha" type="flex" justify="space-between">
                <van-col span="22">
                  <span style="#323233!important"></span>
                  {{item.modelname}}
                </van-col>
                <van-col span="2">
                  <van-icon name="search" @click="tokclist(index)" size="20px" />
                </van-col>
              </van-row>
              <van-row type="flex">
                <van-col span="24">
                  <span style="color:#969799">库存数量:</span>
                  {{item.quantity + item.unit}}
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="20">
                  <span style="color:#969799">出库数量:</span>
                  <input
                      type="text"
                      style="width:70%;border:none"
                      v-model="item.count"
                      @input="handleInput(item)"
                  />
                </van-col>
                <!--<van-col span="4"><van-image round width="0.8rem" height="0.8rem" src="/img/del.png" @click="del(index)"/></van-col>-->
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="20">
                  <span style="color:#969799">失效日期(出库数量):</span>
                  {{item.out_detail}}
                </van-col>
              </van-row>
              <van-row type="flex">
                <van-col span="24">
                  <span style="color:#969799">出库仓库:</span>
                  <van-tag
                      plain
                      type="danger"
                      size="large"
                      color="#838683"
                      v-if="item.warehousename"
                  >{{item.warehousename}}</van-tag>
                </van-col>
              </van-row>
            </van-cell>
          </van-cell-group>
          <van-button
              style="height: 100%;"
              slot="right"
              square
              text="删除"
              type="danger"
              class="delete-button"
              @click="del(index)"
          />
        </van-swipe-cell>
      </van-cell>
      <van-cell>
        <van-icon name="add-o" color="#07c160" size="40" @click="add" style="float:right" />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="上传出库单" :border="false" style="margin-left: 10px;">
      <van-cell style="padding-left:18px">
        <van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead" />
      </van-cell>
    </van-cell-group>

<!--   上线用友关闭-->
    <van-cell-group>
      <van-cell>
        <van-button
            type="info"
            style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold"

            v-bind:disabled="flag"
        >系统切换,不允许出库</van-button>
      </van-cell>
    </van-cell-group>
<!--    <van-cell-group>-->
<!--      <van-cell>-->
<!--        <van-button-->
<!--            type="info"-->
<!--            style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold"-->
<!--            @click="qr"-->
<!--            v-bind:disabled="flag"-->
<!--        >提交出库</van-button>-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->
    <!--   上线用友关闭-->


    <!--<div id="add">-->
    <!--<van-image round width="0.8rem" height="0.8rem" src="/img/add.png" @click="add"/>-->
    <!--</div> -->
    <div
        v-show="bottom_tip"
        style="font-size:10px;text-align:center;padding:10px 10px"
    >©2020 一脉阳光集团信息中心</div>
    <van-dialog v-model="show" title="请仔细核查" show-cancel-button @confirm="qrtj">
      <van-cell-group title="影像中心" :border="false" >
        <van-cell :title="currentAgent.name"/>
      </van-cell-group>
      <van-cell-group title="出库审核员" :border="false" >
        <van-cell :title="checker"/>
      </van-cell-group>
      <van-cell-group title="出库明细" :border="false" >
        <div class="dialogDiv">
        <van-cell
            v-for="(item,index) in outStockDetail"
            :key="index"
        >
          <van-row type="flex">
            <van-col span="6">耗材型号：</van-col>
            <van-col span="18">{{item.modelname}}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">出库数量：</van-col>
            <van-col span="18">{{item.count}}</van-col>
          </van-row>
        </van-cell>
        </div>
      </van-cell-group>
    </van-dialog>
    <van-dialog v-model="tip" title="提示" :show-cancel-button="false" @confirm="qrtip">
      <van-cell-group :title="currentAgent.name" :border="false" >
        <van-cell title='当前影像中心存在过期耗材,过期耗材请先走"报损出库"~~~'/>
      </van-cell-group>
      <van-cell-group title="过期明细" :border="false" >
        <div class="dialogDiv">
          <van-cell
              v-for="(item,index) in stockoverdue"
              :key="index"
          >
            <van-row type="flex">
              <van-col span="6">耗材型号：</van-col>
              <van-col span="18">{{item.modelname}}</van-col>
            </van-row>
            <van-row type="flex">
              <van-col span="5">数量：</van-col>
              <van-col span="9">{{item.quantity}}</van-col>
              <van-col span="9">失效日期：</van-col>
              <van-col span="9">{{item.exp_date}}</van-col>
            </van-row>
          </van-cell>
        </div>
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import {
  SwipeCell,
  NavBar,
  Tag,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Icon,
  Image,
  Toast,
  Uploader,
} from "vant";
import axios from "axios";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Image.name]: Image,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [SwipeCell.name]: SwipeCell,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      show:false,
      fileList: [],
      message: "",
      bottom_tip: true,
      defaultDetail: 0,
      //当前选中的影像中心
      currentAgent: "",
      img_url:'',
      checker:'',
      flag: false,      //提交入库不重复点击
    };
  },
  methods: {
    ...mapMutations([
      "changePermissionAgent",
      "changeDefaultAgentIndex",
      "changeOutStockDetail",
    ]),
    onClickLeft() {
      this.$router.push("/index");
    },
    tokclist(index) {
      this.$router.push({
        name: "stockinfo",
        query: {
          from: "consuming",
          index: index,
          message: this.message,
        },
      });
    },
    parseSubmitData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (obj[i].count.match(/\D/g)) {
          let num = i + 1;
          message =
              message + "第" + num + "条明细,出库数量包括非法字符或空格\n";
        }
        if (!obj[i].count || obj[i].count == 0) {
          let num = i + 1;
          message = message + "第" + num + "条明细,出库数量为空或0\n";
        }
        if (
            obj[i].count &&
            obj[i].count > obj[i].quantity &&
            obj[i].count != 0 &&
            !obj[i].count.match(/\D/g)
        ) {
          let num = i + 1;
          message =
              message + "第" + num + "条明细,出库数量不能超过库存数量！\n";
        }

        let newobj = {
          stockID: obj[i].stockID,
          warehouseId: obj[i].warehouseId,
          purchaseOrderNum: 0,
          purchaseOrderDetailId: 0,
          branduuid: obj[i].branduuid,
          modeluuid: obj[i].modeluuid,
          unit: obj[i].unit,
          unitcost: obj[i].unitcost,
          quantity: obj[i].count,
          is_gift: obj[i].is_gift,
          stock_detail: obj[i].stock_detail,
          out_detail: obj[i].out_detail,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    qr() {
      this.show = true;
    },
    qrtj() {
      let that = this;
      if (!this.outStockDetail[0]) {
        Toast("明细不能为空");
        return;
      }
      let result = this.parseSubmitData(this.outStockDetail);
      // window.console.log(result);
      if (result.message) {
        Toast(result.message);
        return;
      } else {
        let data = {
          remark: this.message?this.message:"科室领用",
          creater: localStorage.getItem("workcode"),
          projectErpCode: this.currentAgent.erp_code,
          img: this.img_url,
          detail: result.data,
        };
        //window.console.log(data);
        Toast.loading({
          message: "加载中...",
          forbidClick: true,
        });
        this.flag = true;
        //window.console.log(data);
        this.$http({
          method: "post",
          url: "/mobile/stockOutCheck",
          data,
        }).then(function (response) {
          if (response.state == 200) {
            Toast.success("出库成功");
            //window.console.log(response);
            that.$router.push("index");
          }
          this.flag = false;
        }).catch(()=>{

        }).finally(() => {
          this.flag = false;
        });
      }
    },
    qrtip(){
      const that = this;  // 声明后需使用
      that.tip = true;
      that.$router.push("index");
    },
    del(index) {
      let obj = {
        index,
        operator: "del",
      };
      this.$store.commit("changeOutStockDetail", obj);
    },
    add() {
      let obj = {
        operator: "add",
      };
      this.changeOutStockDetail(obj);
    },
    toggleDetail(index) {
      this.defaultDetail = index;
    },
    handleInput(val) {
      if (val.count.match(/\D/g)) {
        Toast("请勿输入非数字字符或者空格");
      }
      if (val.count>val.quantity) {
        val.count=null;
        Toast("出库数量大于库存请重新输入!");
      }
      var res=[];
      var v_count=val.count;
      // 1. 解析字符串为数组
      val.stock_detail.split(',').map(i => {
        var match = i.match(/^(\d{4}-\d{2}-\d{2})\((\d+)\)/);
        res.push({
          date:match[1],
          num: parseInt(match[2]),
        });
      });
      // 按照日期对数组进行排序（升序）
      res.sort((a, b) => {
        if (a.date === "0000-00-00") return -1;
        if (b.date === "0000-00-00") return 1;
        return new Date(a.date) - new Date(b.date);
      });
      var out_stock_detail='';
      res.forEach(v=>{
        if(v_count!==0){
          if(v_count>v.num){
            out_stock_detail=out_stock_detail+','+v.date+'('+v.num+')';
            v_count=v_count-v.num;
          }else{
            out_stock_detail=out_stock_detail+","+v.date+"("+v_count+")";
            v_count=0;
          }
        }
      });
      val.out_detail =out_stock_detail.slice(1);
    },
    afterRead(file) {
      let _this = this;
      // 此时可以自行将文件上传至服务器
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      file.status = "uploading";
      file.message = "上传中...";
      axios
          .post("/api/mobile/uploadFile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              token: localStorage.getItem("userToken"),
            },
          })
          .then((res) => {
            //window.console.log(res);
            let img = res.data.data.replace(/storage/i, "public");
            _this.img_url = img;
            //window.console.log(img);
            file.status = "success";
            file.message = "上传成功";
          })
          .catch((err) => {
            file.status = "failed";
            file.message = "上传失败";
            window.console.log(err);
          });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex", "outStockDetail"]),
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == "stockinfo") {
      next((vm) => {
        if (vm.$route.params.modelname != null) {
          let info = {
            operator: "update",
            index: vm.$route.params.index,
            modelname: vm.$route.params.modelname,
            warehousename: vm.$route.params.warehousename,
            quantity: vm.$route.params.quantity,
            stockID: vm.$route.params.stockID,
            warehouseId: vm.$route.params.warehouseId,
            branduuid: vm.$route.params.branduuid,
            modeluuid: vm.$route.params.modeluuid,
            unit: vm.$route.params.unit,
            unitcost: vm.$route.params.unitcost,
            is_gift: vm.$route.params.is_gift,
            stock_detail: vm.$route.params.stock_detail
          };
          vm.defaultDetail = vm.$route.params.index;
          vm.message = vm.$route.params.message;
          vm.changeOutStockDetail(info);
        }
      });
    } else {
      next((vm) => {
        let clearall = {
          operator: "clearall",
        };
        vm.changeOutStockDetail(clearall);
      });
    }
  },
  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        // window.console.log(state.defaultAgentIndex);
        return item.id == _this.defaultAgentIndex;
      });
      this.$http
          .post("/mobile/getChecker", {
            projectErpCode: this.currentAgent.erp_code,
          })
          .then(function (response) {
            window.console.log(response);
            _this.checker = response.checker;
          });
      //如果存在过期耗材先提交过期耗材才能出库
      this.$http
          .post("/mobile/stockoverdue", {
            projectErpCode: this.currentAgent.erp_code,
          })
          .then(function (response) {
            if (!(Array.isArray(response.stock) && response.stock.length === 0)) {
              // 处理逻辑
              _this.stockoverdue =response.stock;
              _this.flag = true;
              _this.tip = true;
            }
          });
    } else {
      let _this = this;
      this.$http
          .post("/mobile/rimsAgentList", {
            username: localStorage.getItem("usermobile"),
          })
          .then(function (response) {
            window.console.log(response);
            _this.changePermissionAgent(response.rimsAgent);
            _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
            _this.currentAgent = _this.permissionAgent.find(function (item) {
              // window.console.log(state.defaultAgentIndex);
              return item.id == _this.defaultAgentIndex;
            });
            this.$http
                .post("/mobile/getChecker", {
                  projectErpCode: this.currentAgent.erp_code,
                })
                .then(function (response) {
                  _this.checker = response.checker;
                });
            //如果存在过期耗材先提交过期耗材才能出库
            this.$http
                .post("/mobile/stockoverdue", {
                  projectErpCode: this.currentAgent.erp_code,
                })
                .then(function (response) {
                  if (!(Array.isArray(response.stock) && response.stock.length === 0)) {
                    // 处理逻辑
                    _this.stockoverdue =response.stock;
                    _this.flag = true;
                    _this.tip = true;
                  }
                });
          });
    }
  },
};
</script>
<style scoped lang="less">
.van-nav-bar {
  background: #ffffff;
  color: #323233;
  font-weight: bold;
  /*background: #456;*/
  /*color:white;*/
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: black;
}
.ha {
  border-bottom: 0.2px solid #dcdcdc;
}
.box {
  background-color: #fff;
}

.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
#add {
  position: fixed;
  top: 300px;
  right: 0;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.detailcell {
  line-height: 1rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
  background: #f7f8fa;
}
.dialogDiv {
  height: 250px;
  overflow: auto;
}
</style>